import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  modalTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
      maxWidth: '2100px'
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  menuTogglerBtn: {
    position: 'absolute',
    bottom: '30vh',
    zIndex: 2000,
    right: '-20px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerTableBtn: {
    position: 'absolute',
    bottom: '30vh',
    zIndex: 2000,
    right: '40.5%',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  filterTableMarker: {
    position: 'relative',
    padding: 0,
    width: 40,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      width: '100%',
      height: 3,
      transform: 'translateY(-50%)',
    },
  },
  headerStyle: {
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '18px'
  },
  editBox: {
    border: '1px solid grey',
    borderRadius: 1
  },
  xAxisEditBtn: {
    position: 'absolute',
    top: -33,
    left: '24px'
  },
  yAxisEditBtn: {
    position: 'absolute',
    top: -65,
    left: '-8px'
  },
  cellStyle: {
    fontSize: '16px',
    width: '75px'
  }
}));
export default styles;
